import React from "react";

const Title = ({ title }) => {
  return (
    <div className="section-title pt-5 mt-2 mt-md-5 pt-md-5">
      <h4  >{title}</h4>
      <div />
    </div>
  );
};

export default Title;
